import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { useAppTranslation } from '../../../../../hooks/useAppTranslation'
import { useCurrentSociety } from '../../../../../hooks/useCurrentSociety'
import { i18nSocietyType } from '../../../../../i18n'
import { ErrorView } from '../../../../../views/error/ErrorView'
import { IllustrationChoices } from '../../../../common/Illustration'
import { documentQueries } from '../../../../../api/documents'

interface DocumentsListEmptyStateProps {
  section: string
  noSearchResults: boolean
  documentId?: string
}

export const DocumentsListEmptyState = ({
  documentId,
  section,
  noSearchResults,
}: DocumentsListEmptyStateProps): React.ReactNode => {
  const { translate } = useAppTranslation()
  const { society } = useCurrentSociety()
  const { data: document } = useQuery(documentQueries.getDocument(documentId))
  const getEmptyStateSubTitle = (): string => {
    const currentDocumentName = documentId && document?.name
    if (section === 'board') {
      return translate('documentsList.emptyState.emptyFolderSubtitleBoard', {
        folderName: currentDocumentName?.trim(),
      })
    }
    return translate('documentsList.emptyState.emptyFolderSubtitle', {
      context: i18nSocietyType(society?.societyTypeDisplayName),
      folderName: currentDocumentName?.trim(),
    })
  }

  if (noSearchResults) {
    return (
      <ErrorView
        title={translate('documentsList.emptyState.title')}
        subtitle={translate('documentsList.emptyState.noSearchResultSubtitle')}
        illustration={IllustrationChoices.EMPTY}
      />
    )
  }

  return (
    <ErrorView
      title={translate('documentsList.emptyState.title')}
      subtitle={getEmptyStateSubTitle()}
      illustration={IllustrationChoices.EMPTY}
    />
  )
}
